import {createApp} from "vue";
import i18n from "./i18n";

import "swiper/css";
import "swiper/css/navigation";

import App from "./App.vue";
import {Swiper, SwiperSlide} from "swiper/vue";
import RenderVNode from "@/components/RenderVNode";
import ButtonClose from "@/components/ButtonClose";
import AnchorParser from "@/components/AnchorParser";

const app = createApp(App);
app.component('swiper', Swiper);
app.component('swiper-slide', SwiperSlide);
app.component('render-vnode', RenderVNode);
app.component('button-close', ButtonClose);
app.component('anchor-parser', AnchorParser);
app
    .use(i18n)
    .mount("#website")
;
